import Vue from 'vue'
import processVariablesChecker from './processVariablesChecker.vue'

// Registrar componentes globalmente para que puedan ser cargados dinámicamente
Vue.component('processVariablesChecker', processVariablesChecker)

// Exportamos un objeto con los componentes para facilitar su importación en otros lugares
export default {
  processVariablesChecker
}
